import React from "react";

const WhyGetFunCard = () => {
  return (
    <section className='why-seller py-80'>
      <div className='container'>
        <div className='section-heading text-center mx-auto'>
          <h5 className=''>Why Get the Fun Card?</h5>
          <span className='text-gray-600'>
            One Subscription. Hundreds of Local Deals. All Year Long.
          </span>
        </div>
        <div className='row gy-4 justify-content-center'>
          <div className='col-lg-4 col-sm-6'>
            <div className='why-seller-item text-center'>
              <span className='text-main-two-600 text-72 d-inline-flex'>
                <i className='ph ph-percent' />
              </span>
              <h6 className='my-28'>Real Savings at Real Places</h6>
              <p className='text-gray-600 max-w-392 mx-auto'>
                From restaurants and attractions to coffee shops and spas — every coupon gives you a genuine discount at a local business you'll love.
              </p>
            </div>
          </div>
          <div className='col-lg-4 col-sm-6'>
            <div className='why-seller-item text-center'>
              <span className='text-main-two-600 text-72 d-inline-flex'>
                <i className='ph ph-map-pin' />
              </span>
              <h6 className='my-28'>Explore Like a Local</h6>
              <p className='text-gray-600 max-w-392 mx-auto'>
                The Fun Card doubles as a city guide. Whether you're a tourist or a local, you'll always find something new to try — and save while doing it.
              </p>
            </div>
          </div>
          <div className='col-lg-4 col-sm-6'>
            <div className='why-seller-item text-center'>
              <span className='text-main-two-600 text-72 d-inline-flex'>
                <i className='ph ph-device-mobile' />
              </span>
              <h6 className='my-28'>Simple, Seamless Redemption</h6>
              <p className='text-gray-600 max-w-392 mx-auto'>
                Browse and bookmark coupons on the web or in the app, then simply show your screen at the business. No printing, no clipping, no hassle.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyGetFunCard;
